var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l([3, 1, -2, -3], function (i) {
      return _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          _vm._s(
            (_vm.stats1[i]?.total ?? 0) > (_vm.stats2[i]?.total ?? 0)
              ? "<<"
              : "=="
          )
        ),
        _c(
          "span",
          {
            class: {
              badge: true,
              "badge-success": i === 3,
              "badge-info": i === 1,
              "badge-warning": i < 0,
            },
          },
          [
            _vm._v(
              _vm._s(
                Math.round(
                  Math.abs(
                    (_vm.stats1[i]?.total ?? 0) - (_vm.stats2[i]?.total ?? 0)
                  ) * 10
                ) / 10
              )
            ),
          ]
        ),
        _vm._v(
          _vm._s(
            (_vm.stats1[i]?.total ?? 0) > (_vm.stats2[i]?.total ?? 0)
              ? "=="
              : ">>"
          ) + "\n  "
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }